export const TRANSACTIONS_FILE_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
